// extracted by mini-css-extract-plugin
export default {"metrics":"Dashboard-module__metrics--zXwsD","budgetCard":"Dashboard-module__budgetCard--tjBPa"};